<template>
  <a-flex gap="small" vertical>
    <a-flex class="buttons" gap="middle">
      <a-button
        :disabled="loading"
        :type="selectedButton === 'small' ? 'primary' : 'default'"
        @click="buttonClicked('small')"
      >
        Этикетка: {{ LabelWidthInMm.SMALL }}x{{ LabelHeightInMm.SMALL }}мм
      </a-button>

      <a-button
        :disabled="loading"
        :type="selectedButton === 'large' ? 'primary' : 'default'"
        @click="buttonClicked('large')"
      >
        Этикетка: {{ LabelWidthInMm.LARGE }}x{{ LabelHeightInMm.LARGE }}мм
      </a-button>
    </a-flex>

    <a-spin
      :spinning="previewIsLoading"
      size="small"
      style="align-self: center"
    />

    <canvas ref="targetCanvasRef"></canvas>
  </a-flex>
</template>

<script setup lang="ts">
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import {
  LabelHeightInMm,
  LabelWidthInMm,
} from "@/api/classes/labelTemplate/labelTemplate.dto";
import { computed, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useLabelTemplateStore } from "@/stores/labelTemplate/labelTemplateStore";
import { LabelTemplate } from "@/stores/labelTemplate/models/label-template";

defineProps<{ loading: boolean }>();

const previewIsLoading = ref(true);
const targetCanvasRef = ref<HTMLCanvasElement | null>(null);

const labelTemplateFormState = useLabelTemplateFormStore();
const labelTemplateStore = useLabelTemplateStore();

const formFields = storeToRefs(labelTemplateFormState);

const selectedButton = computed(() =>
  labelTemplateFormState.labelWidthInMmField === LabelWidthInMm.SMALL
    ? "small"
    : "large",
);

const buttonClicked = (type: "small" | "large") => {
  switch (type) {
    case "small":
      labelTemplateFormState.labelWidthInMmField = LabelWidthInMm.SMALL;
      labelTemplateFormState.labelHeightInMmField = LabelHeightInMm.SMALL;
      break;
    case "large":
      labelTemplateFormState.labelWidthInMmField = LabelWidthInMm.LARGE;
      labelTemplateFormState.labelHeightInMmField = LabelHeightInMm.LARGE;
      break;
  }
};

watch(
  () => formFields,
  async ({ previewProductField }) => {
    if (!previewProductField.value) return;

    previewIsLoading.value = true;

    const product = labelTemplateStore.productForPreviewMap.get(
      previewProductField.value,
    );

    const label = labelTemplateFormState.createLabelTemplateFromState();

    if (label && product) {
      const labelClass = new LabelTemplate(label, product);

      labelTemplateStore.currentEditingLabelClass = labelClass;

      if (targetCanvasRef.value) {
        const targetCtx = targetCanvasRef.value.getContext("2d");

        targetCanvasRef.value.width = convertMmToPxForPreview(
          label.labelWidthInMm,
        );
        targetCanvasRef.value.height = convertMmToPxForPreview(
          label.labelHeightInMm,
        );

        if (targetCtx) {
          await labelClass.renderLabel();

          targetCtx.clearRect(
            0,
            0,
            targetCanvasRef.value.width,
            targetCanvasRef.value.height,
          );

          const scale =
            convertMmToPxForPreview(label.labelWidthInMm) /
            labelClass.canvasRef.width;
          targetCtx.scale(scale, scale);
          targetCtx.drawImage(labelClass.canvasRef, 0, 0);
          targetCtx.scale(1 / scale, 1 / scale);
        }
      }
    }

    setTimeout(() => {
      previewIsLoading.value = false;
    });
  },
  { deep: true },
);

const convertMmToPxForPreview = (mm: number) => (mm / 25.4) * 125;
</script>

<style scoped lang="scss">
.buttons {
  .ant-btn {
    flex: 1 1 50%;
  }
}

canvas {
  background: #fff;
  border-radius: 10px;
}
</style>
